export const CHAT_WIDGET_ID = 'full-widget-container';
export const CHAT_CONVERSATION_LIST_ID = 'zendesk-conversation-list';
export const CHAT_MESSAGE_LOG_ID = 'zendesk-message-log';
export const CHAT_MOBILE_DIALOG_ID = 'zendesk-mobile-dialog';
export const CHAT_MOBILE_TITLE_ID = 'zendesk-mobile-dialog-title';
export const CHAT_DESKTOP_PANEL_WIDTH_REM = 27.5;
export const CHAT_DESKTOP_PANEL_WIDTH = `${CHAT_DESKTOP_PANEL_WIDTH_REM}rem`;
export const CHAT_DEFAULT_ROOT_FONT_SIZE_PX = 16;
// Preserves 250px for the expanded NavBar and 640px for the main content.
export const CHAT_DESKTOP_SHELL_SAFE_WIDTH_PX = 890;
export const CHAT_DESKTOP_PINNED_PANEL_WIDTH =
  `clamp(0px, calc(100dvw - ${CHAT_DESKTOP_SHELL_SAFE_WIDTH_PX}px), ${CHAT_DESKTOP_PANEL_WIDTH})`;
export const getChatPanelPinMinViewportWidth = (
  rootFontSizePx = CHAT_DEFAULT_ROOT_FONT_SIZE_PX
) => CHAT_DESKTOP_SHELL_SAFE_WIDTH_PX
  + CHAT_DESKTOP_PANEL_WIDTH_REM * rootFontSizePx;
export const CHAT_PANEL_PIN_UNAVAILABLE_DESCRIPTION_ID =
  'chat-panel-pin-unavailable-description';
